/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect,useRef} from 'react';
import {Box, Grid, Tooltip, Typography, useTheme,  TextField, InputAdornment} from '@mui/material';


import {useSnackbar} from 'notistack';

import {getPageSection} from '@shared/services/service-handlers/PrivateService';
import {getErrorMessage} from '@shared/utils/ErrorUtils';

import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import SubModulePageSection from '../sub-module-page-section/SubModulePageSection';
import {useSelectedCheckBoxContext} from '@context/SelectedCheckBoxContext';
import AuthUtils from 'src/utils/AuthUtils';

import {ButtonDiv} from './SubModuleSearchPageStyles';
import {useTranslation} from 'react-i18next';
import FormConstants from '@shared/constants/FormConstants';
import {CircularProgressDiv} from '@modules/public/main/login/LoginStyles';
import {useAppContext} from '@context/AppContext';
import {LoadingButton} from '@mui/lab';
import CustomBreadcrumbs from 'src/minimal-components/custom-breadcrumbs';
import {LoadingScreen} from 'src/minimal-components/loading-screen';
import {Search as SearchIcon} from '@mui/icons-material';
import {
  BASE_ROUTE,
  BASE_ROUTE_MODULE,
  LOCAL_SEARCH,
  AI_BLOB_SEARCH
} from 'src/routes/BaseRoute';
import EncryptUtils from 'src/utils/EncryptUtils';
import {useSelectedAdditionalCheckBoxContext} from '@context/SelectedAdditionalCheckBoxContext';

type ActiveGlobalSearchBorderBoxProps = {
  content: React.ReactNode;
};

const SubModuleSearchPage = (props: any): React.ReactElement => {
  const {
    appState: {applicationName}
  } = useAppContext();

  const theme = useTheme();

  const {enqueueSnackbar} = useSnackbar();
  const {t} = useTranslation();

  // States
  const [sectionsData, setSectionsData]: any = React.useState();
  const [isPageLoading, setIsPageLoading] = React.useState<boolean>(false);
  const [filterCheckedData, setFilterCheckedData] = React.useState<any>({
    data: [],
    count: 0,
    list: []
  });
  
  const [tableRefresh, setTableRefresh] = React.useState(false);
  const [documentsSearchTerm, setDocumentsSearchTerm] = React.useState<string>('');
    const [debouncedDocumentsSearchInput, setDebouncedDocumentsSearchInput] =
    React.useState<string>('');
  const [debouncedDocumentsSearchTerm, setDebouncedDocumentsSearchTerm] = React.useState<string>('');
  const hasShownMinSearchSnackbarRef = useRef(false);
  const [state, setState] = React.useState<any>({
    uiConfig: [],
    submodule: false,
    sub_sections: [],
    data: [],
    loader: false
  });
  const [filteron, setFilteron] = React.useState<{
    filtered: boolean;
    cleared: boolean;
  }>({
    filtered: false,
    cleared: true
  });
  const {data, loader} = state;

  // Context
  const {SelectedCheckBoxState, setSelectedCheckBoxData} =
    useSelectedCheckBoxContext();
  const {SelectedAdditionalCheckBoxState, setSelectedAdditionalCheckBoxData} =
    useSelectedAdditionalCheckBoxContext();
  // local storage
  const getLocaleStorageData = AuthUtils.getSelectedCheckBoxData();

  const getAdditionalLocaleStorageData =
    AuthUtils.getSelectedAdditionalCheckBoxData();
  const getPatientvalues = AuthUtils.getPatientAccountingSelectedCheckBoxList();

  const localSearch = EncryptUtils.getDecryptedData(
    location?.search,
    LOCAL_SEARCH
  );
  const parsedLocalSearch = localSearch ? JSON.parse(localSearch) : {};

  const aiBlobSearch = EncryptUtils.getDecryptedData(
    location?.search,
    AI_BLOB_SEARCH
  );
  const parsedAiBlobSearch = aiBlobSearch ? JSON.parse(aiBlobSearch) : {};

  const isLocalSearchActive =
    Object.keys(parsedLocalSearch)?.length > 0 &&
    parsedLocalSearch?.is_local_search;

  const isAiBlobSearchActive =
    Object.keys(parsedAiBlobSearch)?.length > 0 &&
    parsedAiBlobSearch?.is_ai_blob_search;
      const isClinicalDocumentsPage =
    props?.module === FormConstants.MODULE.CLINICAL &&
    props?.sub_module === FormConstants.SUB_MODULE.DOCUMENTS;

  useEffect(() => {
    const debounceTimer = window.setTimeout(() => {
      const normalizedSearchTerm = documentsSearchTerm.trim();
      setDebouncedDocumentsSearchInput(documentsSearchTerm);
      setDebouncedDocumentsSearchTerm(
        normalizedSearchTerm.length >= 2 ? documentsSearchTerm : ''
      );
    }, 500);

    return () => window.clearTimeout(debounceTimer);
  }, [documentsSearchTerm]);

  // useEffect(() => {
  //   const normalizedSearchTerm = documentsSearchTerm.trim();

  //   if (normalizedSearchTerm.length > 0 && normalizedSearchTerm.length < 2) {
  //     if (!hasShownMinSearchSnackbarRef.current) {
  //       enqueueSnackbar('Enter at least 2 characters', SnackBarConfig.getError());
  //       hasShownMinSearchSnackbarRef.current = true;
  //     }
  //     return;
  //   }

  //   hasShownMinSearchSnackbarRef.current = false;
  // }, [documentsSearchTerm, enqueueSnackbar]);

  const handleApplyFilterClick = () => {
    setSelectedCheckBoxData({data: filterCheckedData.data});
    AuthUtils.setSelectedCheckBoxData(
      JSON.stringify(
        filterCheckedData.data.length > 0 ? filterCheckedData.data : ''
      )
    );
    AuthUtils.setSelectedCheckBoxList(filterCheckedData.list);
    if (
      props.module === FormConstants.MODULE.PATIENT_ACCOUNTING &&
      props.sub_module === FormConstants.SUB_MODULE.ACCOUNTS
    ) {
      AuthUtils.setPatientAccountingSelectedCheckBoxList(
        JSON.stringify(
          filterCheckedData.data.length > 0 ? filterCheckedData.data : ''
        )
      );
    }
    if (filterCheckedData.data.length > 0) {
      props.applyFilterClicked(true);
    }
  };

  const handleCheckBoxClick = (data: any, ids: any) => {
    if (data) {
      setFilterCheckedData((prevState: any) => ({
        ...prevState,
        data: data,
        count: data.length,
        list: ids
      }));
    }
  };

  const initFilterData = () => {
    if (getLocaleStorageData) {
      let filterDataCount = 0;

      const filterData = JSON.parse(getLocaleStorageData);

      if (filterData) {
        const checkedRowIds = filterData?.map((row: any) => {
          return row?.ID;
        });

        if (checkedRowIds && checkedRowIds.length)
          filterDataCount = checkedRowIds.length;

        if (checkedRowIds.length === 0) {
          filterDataCount = 0;
        }
      }

      setFilterCheckedData((prevState: any) => ({
        ...prevState,
        count: filterDataCount
      }));
    }
    if (
      getAdditionalLocaleStorageData &&
      localStorage.getItem('patient_encounterData_removed') === 'false'
    ) {
      let filterDataCount = 0;
      let ids = [];
      const filterData = JSON.parse(getAdditionalLocaleStorageData);

      if (filterData) {
        const checkedRowIds = filterData?.map((row: any) => {
          return row?.ID;
        });

        if (checkedRowIds && checkedRowIds.length)
          filterDataCount = checkedRowIds.length;

        if (checkedRowIds.length === 0) {
          filterDataCount = 0;
        }
        ids = checkedRowIds;
      }

      setFilterCheckedData({
        data: filterData,
        count: filterDataCount,
        list: ids
      });
    }
  };
  const accountlocalstorage = localStorage.getItem('account_number_id');
  // const encounterlocalstorage = localStorage.getItem('encounter_number_id');
  useEffect(() => {
    if (accountlocalstorage && filterCheckedData.data.length > 0) {
      // handleApplyFilterClick();
      // props.applyFilterClicked(false);

      setFilteron({filtered: true, cleared: false});
    }

    if (getAdditionalLocaleStorageData && filterCheckedData.data.length > 0) {
      // handleApplyFilterClick();
      props.applyFilterClicked(true);
      setFilteron({filtered: true, cleared: false});
    }
  }, []);
  useEffect(() => {
    const getPatientAccoutningCheckData =
      AuthUtils.getPatientAccountingSelectedCheckBoxList();

    if (
      (accountlocalstorage || getPatientAccoutningCheckData) &&
      (props?.sub_module === FormConstants.SUB_MODULE.ACCOUNTS ||
        props?.sub_module === FormConstants.SUB_MODULE.ENCOUNTERS) &&
      (props?.module === FormConstants.MODULE.PATIENT_ACCOUNTING ||
        props?.module === FormConstants.MODULE.CLINICAL) &&
      filterCheckedData.data.length > 0
    ) {
      if (
        localStorage.getItem('account_number_fetched') === 'false' &&
        filterCheckedData.data.length > 0
      ) {
        handleApplyFilterClick();
        localStorage.setItem('account_number_fetched', 'true');
      }
      setFilteron({filtered: true, cleared: false});
    }
  }, [accountlocalstorage, filterCheckedData]);
  useEffect(() => {
    if (
      getAdditionalLocaleStorageData &&
      props?.sub_module === FormConstants.SUB_MODULE.ENCOUNTERS &&
      props?.module === FormConstants.MODULE.CLINICAL &&
      filterCheckedData.data.length > 0
    ) {
      if (
        localStorage.getItem('Patient_encounter_number_fetched') === 'false' &&
        filterCheckedData.data.length > 0
      ) {
        handleApplyFilterClick();
        localStorage.setItem('Patient_encounter_number_fetched', 'true');
      }
      setFilteron({filtered: true, cleared: false});
    }
  }, [getAdditionalLocaleStorageData, filterCheckedData]);

  const init = async () => {
    try {
      if (props?.module && props?.sub_module && props?.record_id) {
        setIsPageLoading(true);
        const res = await getPageSection(
          applicationName,
          props.module,
          props.sub_module,
          props.menuItem
        );
        setSectionsData(res);
        setIsPageLoading(false);
        setFilterCheckedData({
          data: [],
          count: 0,
          list: []
        });
      }
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setIsPageLoading(false);
    }
    if (
      SelectedCheckBoxState.selectionData.length > 0 ||
      SelectedAdditionalCheckBoxState.selectionData.length > 0
    ) {
      initFilterData();
    }
  };

  React.useEffect(() => {
    initFilterData();
  }, [SelectedCheckBoxState]);

  const handleCloseFilterClick = () => {
    props.applyFilterClicked(false);
    AuthUtils.clearSelectedCheckBoxData();
    AuthUtils.clearSelectedCheckBoxList();

    setFilterCheckedData((prevState: any) => ({
      ...prevState,
      data: [],
      count: 0,
      list: []
    }));
    handleCheckBoxClick({data: {}}, []);
    setSelectedCheckBoxData({data: {}});
    if (props.sub_module === FormConstants.SUB_MODULE.ENCOUNTERS) {
      localStorage.setItem('patient_encounterData_removed', 'true');
    }
    if (getAdditionalLocaleStorageData) {
      setSelectedAdditionalCheckBoxData({data: {}});
      // AuthUtils.clearAdditionalSelectedCheckBoxList();
      // AuthUtils.clearSelectedAdditionalCheckBoxData();
      // AuthUtils.clearPatientAccountingSelectedCheckBoxList();
      localStorage.removeItem('Patient_encounter_number_fetched');
      setTableRefresh(true);
    }
    if (localStorage.getItem('encounter_number_id')) {
      localStorage.removeItem('encounter_number_id');
      localStorage.removeItem('encounterIsBH');
      localStorage.removeItem('account_number_Date_id');
      localStorage.removeItem('account_number_Legacy_App');
      localStorage.removeItem('account_number_Legacy_Mrn');
      localStorage.removeItem('account_number_fetched');
      localStorage.removeItem('account_number_date');
      setTableRefresh(true);
    }
    if (
      localStorage.getItem('account_number_id') &&
      props?.module === FormConstants.MODULE.PATIENT_ACCOUNTING &&
      props.sub_module === FormConstants.SUB_MODULE.ACCOUNTS
    ) {
      localStorage.removeItem('account_number_id');
      setTableRefresh(true);
    }
    localStorage.removeItem('encounterIsBH');
  };

  function formatModuleName(moduleName: string): string {
    if (!moduleName || moduleName.length <= 3) {
      return (moduleName || '').toUpperCase();
    }

    const [firstTwoLetters, rest] = moduleName.split('-');

    // Capitalize first two letters if module name contains only two letters before hyphen
    if (firstTwoLetters.length === 2) {
      const formattedFirstTwoLetters = firstTwoLetters.toUpperCase();
      return `${formattedFirstTwoLetters} ${
        rest.charAt(0).toUpperCase() + rest.slice(1)
      }`;
    }

    const words = moduleName.replace(/_/g, ' ').split(/-| /);

    const formattedModuleName = words
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

    return formattedModuleName;
  }

  React.useEffect(() => {
    init();
    if (
      props?.module === FormConstants.MODULE.RIS &&
      props?.sub_module !== FormConstants.SUB_MODULE.EXAM_PROCEDURE_LIST
    ) {
      setState((prev: any) => ({
        ...prev,
        uiConfig: [],
        submodule: false,
        sub_sections: [],
        data: [],
        loader: false
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.module, props?.sub_module, props?.record_id, props.menuItem]);

  useEffect(() => {
    if (props?.sub_module === FormConstants.SUB_MODULE.ENCOUNTERS) {
      if (getAdditionalLocaleStorageData) {
      } else if (localStorage.getItem('account_number_id')) {
      } else {
        handleCloseFilterClick();
      }
    }
  }, [props.ParentLegacyValue]);

  const breadcrumbsLinks =
    (props?.sub_module === 'vital' || props?.sub_module === 'reports') &&
    props?.module != 'lis'
      ? null
      : data?.row?.ProcedureType?.length > 0
        ? [
            {
              name: formatModuleName(props?.module),
              href: `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${props.module}`
            },
            {
              name: formatModuleName(props?.sub_module),
              clickable: true,
              onClick: () =>
                setState((prev: any) => ({
                  ...prev,
                  uiConfig: [],
                  submodule: false,
                  sub_sections: [],
                  data: [],
                  loader: false
                }))
            },
            {name: data?.row?.ProcedureType}
          ]
        : [
            {
              name: formatModuleName(props?.module),
              href: `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${props.module}`
            },
            {
              name: props?.sub_module === 'productinfo' ? 'Product Info' : formatModuleName(props?.sub_module)
            }
          ];

  const ActiveGlobalSearchBorderBox: React.FC<
    ActiveGlobalSearchBorderBoxProps
  > = ({content}) => {
    return (
      <Box
        sx={{
          display: 'inline-block',
          marginTop: '10px',
          marginLeft: '20px',
          padding: '7px',
          border: '1px dashed green',
          borderRadius: '10px'
        }}>
        {content}
      </Box>
    );
  };

  const globalSearchContent = (
    <Typography color="textPrimary">
      {'You have enabled '}
      <span style={{fontWeight: 'bold'}}>global search</span>
      {'. To reset press '}
      <span style={{fontWeight: 'bold'}}>cancel</span>
      {' in the header.'}
    </Typography>
  );

  const pathContent = (
    <Box
      sx={{
        maxWidth: 450,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
      }}>
      <Tooltip title={parsedAiBlobSearch?.filePath || 'Not Found'} arrow>
        <Typography
          component="span"
          sx={{
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}>
          <span style={{fontWeight: 'bold'}}>Path: </span>
          {parsedAiBlobSearch?.filePath || 'Not Found'}
        </Typography>
      </Tooltip>
    </Box>
  );

  return isPageLoading || loader ? (
    <CircularProgressDiv>
      <LoadingScreen />
    </CircularProgressDiv>
  ) : (
    <>
      <Grid container alignItems="center" justifyContent={'space-between'}>
        <Grid
          item
          sx={{
            display: 'flex'
          }}>
        {isClinicalDocumentsPage && (
            <Box sx={{mt: 2, mr: 2, minWidth: 190}}>
              <TextField
                fullWidth
                size="small"
                placeholder="Search..."
                value={documentsSearchTerm}
                onChange={e => setDocumentsSearchTerm(e.target.value)}
                                helperText={
                  debouncedDocumentsSearchInput.trim().length > 0 &&
                  debouncedDocumentsSearchInput.trim().length < 2
                    ? 'Enter at least 2 characters'
                    : ' '
                }
                FormHelperTextProps={{
                  sx: {
                    color:
                      debouncedDocumentsSearchInput.trim().length > 0 &&
                      debouncedDocumentsSearchInput.trim().length < 2
                        ? theme.palette.error.main
                        : 'transparent'
                  }
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{color: theme.palette.text.disabled}} />
                    </InputAdornment>
                  )
                }}
              />
            </Box>
          )}
          <CustomBreadcrumbs
            links={breadcrumbsLinks || []}
            sx={{
              mt: 2
            }}
          />
          {(isLocalSearchActive || isAiBlobSearchActive) && (
            <ActiveGlobalSearchBorderBox content={globalSearchContent} />
          )}
        </Grid>

        {parsedAiBlobSearch?.filePath && isAiBlobSearchActive && (
          <Grid item>
            <ActiveGlobalSearchBorderBox content={pathContent} />
          </Grid>
        )}

        {data?.row?.ProcedureType?.length > 0 && (
          <Grid item sx={{display: 'flex', gap: 2, mr: 1, mt: 2}}>
            <div style={{display: 'flex', alignItems: 'center', gap: '2px'}}>
              <Typography variant="subtitle2" noWrap>
                Accession Number:
              </Typography>
              <Typography variant="body2" sx={{color: 'text.secondary'}} noWrap>
                {state?.data?.row?.AccessionNumber}
              </Typography>
            </div>
            <div style={{display: 'flex', alignItems: 'center', gap: '2px'}}>
              <Typography variant="subtitle2" noWrap>
                Procedure Type:
              </Typography>
              <Typography variant="body2" sx={{color: 'text.secondary'}} noWrap>
                {state.data?.row?.ProcedureType}
              </Typography>
            </div>
          </Grid>
        )}
      </Grid>
      <Grid container>
        {sectionsData?.sections?.map?.((item: any, index: number) => {
          return (
            <div key={index} style={{width: '100%'}}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'content',
                  alignItems: 'center',
                  flexDirection: 'row',
                  height: '16px',
                  width: '100%',
                  marginTop: '0.5rem',
                  marginBottom:
                    item?.heading === 'Encounters' ||
                    item?.heading === 'Accounts'
                      ? '1rem'
                      : 0
                }}>
                <Grid
                  style={{
                    paddingLeft: item?.heading === 'Vitals' ? '0.5rem' : '0'
                  }}>
                  {item?.heading === 'Legacy MRNs' ? (
                    <Typography
                      color="primary"
                      style={{
                        fontWeight: 'bold',
                        marginTop: '1rem',
                        color: `${theme.palette.common.black}`
                      }}>
                      {item?.heading}
                    </Typography>
                  ) : null}
                </Grid>
                {item?.is_selection_needed ? (
                  <ButtonDiv>
                    <LoadingButton
                      disabled={
                        item?.is_selection_needed && filteron.filtered
                          ? false
                          : true
                      }
                      type="reset"
                      variant={
                        item?.is_selection_needed && filteron.filtered
                          ? 'outlined'
                          : 'contained'
                      }
                      sx={{
                        backgroundColor: theme.palette.primary.light
                      }}
                      style={{fontWeight: 'normal'}}
                      onClick={() => {
                        handleCloseFilterClick();
                        setFilteron({filtered: false, cleared: true});
                      }}>
                      {t('PRIVATE.DASHBOARD.FILTERS.CLEAR_FILTER', {
                        ns: 'private'
                      })}
                    </LoadingButton>
                    <LoadingButton
                      type="submit"
                      variant="contained"
                      disabled={filterCheckedData.count > 0 ? false : true}
                      onClick={() => {
                        handleApplyFilterClick();
                        setFilteron({filtered: true, cleared: false});
                      }}
                      sx={{
                        backgroundColor: theme.palette.primary.dark,
                        marginLeft: '10px'
                      }}>
                      {t('PRIVATE.DASHBOARD.FILTERS.APPLY_FILTER', {
                        ns: 'private'
                      })}{' '}
                      {filterCheckedData.count > 0
                        ? `(` + filterCheckedData.count + `)`
                        : ''}
                    </LoadingButton>
                  </ButtonDiv>
                ) : (
                  ''
                )}
              </div>
              <Grid
                item
                xs={12}
                style={{
                  marginTop:
                    item?.heading === 'Legacy MRNs' ||
                    item?.heading === 'Encounters' ||
                    item?.heading === 'Accounts'
                      ? '1rem'
                      : '-1rem'
                }}>
                <SubModulePageSection
                  sectionUIData={item}
                  module={props?.module}
                  sub_module={props?.sub_module}
                  record_id={props?.record_id}
                  specimen_number_id={props?.specimen_number_id}
                  specimen_number={props?.specimen_number}
                  accessionNumber={props?.accessionNumber}
                  procedure_id={props?.procedure_id}
                  demographic_id={props?.demographic_id}
                  specimen_type={props?.specimen_type}
                  handleCheckBoxClick={handleCheckBoxClick}
                  filteredcheckData={filterCheckedData}
                  clearSelectedDataCount={filterCheckedData.count}
                  tableRefresh={tableRefresh}
                  setTableRefresh={setTableRefresh}
                  legacyApp={props?.legacyApp}
                  ParentLegacyValue={props?.ParentLegacyValue}
                  unique_id={props?.unique_id}
                  state={state}
                  setState={setState}
                  documentsSearchTerm={debouncedDocumentsSearchTerm}
                />
              </Grid>
            </div>
          );
        })}
      </Grid>
    </>
  );
};

export default SubModuleSearchPage;
